import React, { useState } from 'react';
import { Calendar, Clock, MapPin, ChevronLeft, Users } from 'lucide-react';
import { formatDate, formatTime } from '../../utils/dateTime';
import type { Practice } from '../../types';
import PracticeAttendance from './PracticeAttendance';
import { useTeamStore } from '../../store/teamStore';

interface PracticeHeaderProps {
  practice: Practice | null;
  isMobileView: boolean;
  timeFormat: '12h' | '24h';
  onBackToPractices: () => void;
}

export function PracticeHeader({
  practice,
  isMobileView,
  timeFormat,
  onBackToPractices
}: PracticeHeaderProps) {
  const { currentTeam } = useTeamStore();
  const [showAttendance, setShowAttendance] = useState(false);

  if (!practice) return null;

  return (
    <>
      <div className="bg-white rounded-lg shadow-md p-4 mb-6">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center">
            {isMobileView && (
              <button
                onClick={onBackToPractices}
                className="mr-2 p-1 rounded-full hover:bg-gray-100"
                aria-label="Back to practices"
              >
                <ChevronLeft size={20} />
              </button>
            )}
            <h2 className="text-xl font-semibold">{practice.theme}</h2>
          </div>
          <button
            onClick={() => setShowAttendance(!showAttendance)}
            className="flex items-center gap-2 px-3 py-1.5 text-sm bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
          >
            <Users size={16} />
            {showAttendance ? 'Hide' : 'Take'} Attendance
          </button>
        </div>
        
        <div className="flex flex-col gap-2 text-sm text-gray-600">
          <div className="flex items-center">
            <Calendar size={16} className="mr-2" />
            {formatDate(practice.date)}
          </div>
          <div className="flex items-center">
            <Clock size={16} className="mr-2" />
            {formatTime(practice.start_time, timeFormat)} - {formatTime(practice.end_time, timeFormat)}
          </div>
          <div className="flex items-center">
            <MapPin size={16} className="mr-2" />
            {practice.location}
          </div>
        </div>
      </div>

      {showAttendance && currentTeam && (
        <div className="mb-6">
          <PracticeAttendance
            practice={practice}
            teamId={currentTeam.id}
            onClose={() => setShowAttendance(false)}
          />
        </div>
      )}
    </>
  );
}

export default PracticeHeader; 